var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Plus-/-Special",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(5.000000, 5.000000)",
    fill: "#00A3E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.29675,8.44175 L9.72625,8.44175 L9.72625,0.8695 C9.72625,0.54925 9.4655,0.2885 9.1435,0.2885 C8.8215,0.2885 8.56075,0.54925 8.56075,0.8695 L8.56075,8.44175 L0.99025,8.44175 C0.668775,8.44175 0.40785,8.7025 0.40785,9.024675 C0.40785,9.3465 0.668775,9.6055 0.99025,9.6055 L8.56075,9.6055 L8.56075,17.17775 C8.56075,17.49975 8.8215,17.7605 9.1435,17.7605 C9.4655,17.7605 9.72625,17.49975 9.72625,17.17775 L9.72625,9.6055 L17.29675,9.6055 C17.61875,9.6055 17.8795,9.3465 17.8795,9.024675 C17.8795,8.7025 17.61875,8.44175 17.29675,8.44175 Z",
    id: "plus"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusZoom);
export default __webpack_public_path__ + "static/media/plus-zoom.f65105b360801fc8f6db5c916e1642cb.svg";
export { ForwardRef as ReactComponent };